import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './app.layout.html'
})
export class AppLayoutComponent {}
